// src/services/referralsApi.js
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function handleResponse(response) {
    const contentType = response.headers.get('content-type');
    let data;
    if (contentType && contentType.includes('application/json')) {
        data = await response.json();
    } else {
        data = { error: `Unexpected response type: ${contentType}`, responseText: await response.text() };
    }
    if (!response.ok) {
        const err = new Error(data.error || data.message || `HTTP error! status: ${response.status}`);
        err.status = response.status;
        err.data = data;
        throw err;
    }
    return data;
}

/**
 * Fetch the current user's referral code, shareable link, and stats.
 * Backend lazy-generates a code if the user predates the feature.
 */
export const fetchMyReferral = async (token) => {
    const response = await fetch(`${API_URL}/referrals/my-referral`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return handleResponse(response);
};

/**
 * Check whether a code is valid (used for live signup-form validation).
 * Unauthenticated.
 */
export const validateReferralCode = async (referralCode) => {
    const response = await fetch(`${API_URL}/referrals/validate-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ referral_code: referralCode }),
    });
    return handleResponse(response);
};

/**
 * Is the current user eligible for the 10%-off referral discount on the
 * given purchase type? Used to show/hide the discount banner at checkout.
 */
export const fetchDiscountEligibility = async (token, purchaseType = 'credits') => {
    const url = new URL(`${API_URL}/referrals/discount-eligibility`);
    url.searchParams.set('purchase_type', purchaseType);
    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    return handleResponse(response);
};
